import React from "react"

const LABEL = {
	queued: "Being read",
	failed: "Could not read",
	type: "Needs a type",
	overdue: "Review overdue",
	pdf: "No PDF",
	ready: "Ready",
}

export function StatusIcon({ kind }) {
	const label = LABEL[kind]
	const a11y = label ? { role: "img", "aria-label": label } : { "aria-hidden": true }
	switch (kind) {
		case "queued":
			return (
				<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent-interactive)" strokeWidth="2" strokeLinecap="round" style={{ flexShrink: 0 }} {...a11y}>
					<circle cx="12" cy="12" r="9" strokeDasharray="3 3" />
				</svg>
			)
		case "failed":
			return (
				<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C62828" strokeWidth="2" strokeLinecap="round" style={{ flexShrink: 0 }} {...a11y}>
					<circle cx="12" cy="12" r="9" />
					<path d="M9 9l6 6M15 9l-6 6" />
				</svg>
			)
		case "type":
			return (
				<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#B26A00" strokeWidth="2" strokeLinecap="round" style={{ flexShrink: 0 }} {...a11y}>
					<circle cx="12" cy="12" r="9" />
					<path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .8-1 1.5V14M12 17.2v.3" />
				</svg>
			)
		case "overdue":
			return (
				<svg width="16" height="16" viewBox="0 0 24 24" style={{ flexShrink: 0 }} {...a11y}>
					<circle cx="12" cy="12" r="10" fill="#C62828" />
					<path d="M12 7v6M12 16.5v.5" stroke="#ffffff" strokeWidth="2.4" strokeLinecap="round" />
				</svg>
			)
		case "pdf":
			return (
				<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5b6472" strokeWidth="2" style={{ flexShrink: 0 }} {...a11y}>
					<path d="M14 3H6v18h12V7z" />
					<path d="M14 3v4h4M4 4l16 16" />
				</svg>
			)
		case "ready":
			return (
				<svg width="16" height="16" viewBox="0 0 24 24" style={{ flexShrink: 0 }} {...a11y}>
					<circle cx="12" cy="12" r="10" fill="#2E7D32" />
					<path d="M7.5 12.5l3 3 6-6.5" fill="none" stroke="#ffffff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			)
		default:
			return (
				<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5b6472" strokeWidth="2" style={{ flexShrink: 0 }} aria-hidden="true">
					<path d="M14 3H6v18h12V7z" />
					<path d="M14 3v4h4" />
				</svg>
			)
	}
}
